import { useState } from 'react'
import { Link } from 'react-router-dom'
import { lumi } from '../lib/lumi'
import {UserPlus} from 'lucide-react'

export default function Cadastro() {
  const [formData, setFormData] = useState({
    nomeCompleto: '',
    email: '',
    senha: '',
    pais: '',
    profissao: ''
  })
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const handleCadastro = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    try {
      await lumi.auth.signIn()
    } catch (err: any) {
      setError(err.message || 'Erro ao criar conta')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4 py-8">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <img 
            src="https://static.lumi.new/94/94387bd69277769ec0567b4f6dbc1e0e.webp" 
            alt="Logo" 
            className="h-16 w-auto mx-auto mb-3"
          />
          <h1 className="text-4xl font-bold text-[#8B0000] mb-2">Unovalinks</h1>
          <p className="text-gray-600 text-lg">
            Crie sua conta e comece a fechar clientes de forma profissional.
          </p>
        </div>

        {/* Form */}
        <div className="bg-white border-2 border-gray-100 rounded-2xl p-8 shadow-sm">
          <form onSubmit={handleCadastro} className="space-y-5">
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Nome completo
              </label>
              <input
                type="text"
                name="nomeCompleto"
                value={formData.nomeCompleto}
                onChange={handleChange}
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#8B0000] focus:outline-none transition-colors"
                placeholder="Seu nome"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                E-mail
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#8B0000] focus:outline-none transition-colors"
                placeholder="seu@email.com"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Senha
              </label>
              <input
                type="password"
                name="senha"
                value={formData.senha}
                onChange={handleChange}
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#8B0000] focus:outline-none transition-colors"
                placeholder="••••••••"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                País
              </label>
              <select
                name="pais"
                value={formData.pais}
                onChange={handleChange}
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#8B0000] focus:outline-none transition-colors"
                required
              >
                <option value="">Selecione</option>
                <option value="Brasil">Brasil</option>
                <option value="Portugal">Portugal</option>
                <option value="Angola">Angola</option>
                <option value="Moçambique">Moçambique</option>
                <option value="Outro">Outro</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Profissão
              </label>
              <input
                type="text"
                name="profissao"
                value={formData.profissao}
                onChange={handleChange}
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#8B0000] focus:outline-none transition-colors"
                placeholder="Ex: Designer, Programador"
                required
              />
            </div>

            {error && (
              <div className="text-[#8B0000] text-sm text-center">{error}</div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#8B0000] text-white py-4 rounded-lg font-semibold text-lg hover:bg-[#6B0000] transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            >
              <UserPlus size={20} />
              {loading ? 'Criando conta...' : 'Criar conta'}
            </button>
          </form>

          <div className="mt-6 text-center text-gray-600">
            Já tem conta?{' '}
            <Link to="/login" className="text-[#8B0000] hover:text-[#6B0000] font-semibold">
              Entrar
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
